import { useEffect } from 'react';
import { withWindow } from '@shared/utils/withWindow';

export const useKeycodeListener = (
  keys: readonly number[],
  callback: () => void,
  options?: Partial<Pick<KeyboardEvent, 'altKey' | 'ctrlKey' | 'shiftKey'>>,
  deps: readonly unknown[] = [],
) => {
  useEffect(() => {
    const match = (event: KeyboardEvent) => {
      if (options) {
        if (options.altKey !== undefined && options.altKey !== event.altKey) {
          return false;
        }
        if (options.ctrlKey !== undefined && options.ctrlKey !== event.ctrlKey) {
          return false;
        }
        if (options.shiftKey !== undefined && options.shiftKey !== event.shiftKey) {
          return false;
        }
      }
      return keys.includes(event.keyCode);
    };

    const onDown = (event: KeyboardEvent) => {
      if (match(event)) {
        callback();
      }
    };

    withWindow(window => {
      window.addEventListener('keydown', onDown);
    });
    return () => {
      withWindow(window => {
        window.removeEventListener('keydown', onDown);
      });
    };
    // Include keys, callback, and options in dependency array along with custom deps
    // This ensures the listener updates when any of these values change
  }, [keys, callback, options, deps]);
};
